import styled from 'styled-components';
import * as React from 'react';
import { BoldTinyBodyText } from '../Typography/basicTypography';
import { DropdownItem, IDropdownItemProps } from './DropdownItem';

const StyledList = styled.ul`
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  list-style: none;
  margin: 0;
  padding: 0 0 ${(props) => props.theme.spacing.spacing4} 0;
`;

const StyledName = styled(BoldTinyBodyText)`
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  color: ${(props) => props.theme.colors.defaultContentText};
  padding: ${(props) => props.theme.spacing.spacing4};
  padding-bottom: ${(props) => props.theme.spacing.spacing2};
  text-transform: uppercase;
`;

export interface IDropdownGroupProps {
  name: string;
  items: IDropdownItemProps[];
}

export const DropdownGroup: React.FC<IDropdownGroupProps> = ({ name, items }) => (
  <div>
    <StyledName>{name}</StyledName>
    <StyledList>
      {items.map((itemProps, i) => (
        <li key={i}>
          <DropdownItem displayAsGroup={true} {...itemProps} />
        </li>
      ))}
    </StyledList>
  </div>
);
